import {Component, Input, OnChanges} from '@angular/core';
import * as moment from 'moment';
import {FormControl, FormGroup, Validators} from '@angular/forms';

moment.locale('el-GR');

@Component({
  selector: 'app-add-refrigerator-second-step',
  styleUrls: ['./add-refrigerator-second-step.component.scss'],
  templateUrl: './add-refrigerator-second-step.component.html'
})
export class AddRefrigeratorSecondStepComponent implements OnChanges {
  @Input() checkDescription: any;
  @Input() details: any;
  @Input() stock: any;
  public formGroup: FormGroup;
  public showNewRefrigerators: any;
  public showUsedRefrigerators: any;

  constructor() {
    this.formGroup = new FormGroup({
      new_refrigerator_count: new FormControl(null, Validators.min(1)),
      used_refrigerator_count: new FormControl(null, Validators.min(1))
    });
  }

  public async ngOnChanges(): Promise<any> {
    if (this.details) {
      if (this.details.refrigerator_category === 8) {
        this.showNewRefrigerators = true;
        this.showUsedRefrigerators = false;
      } else {
        this.showUsedRefrigerators = true;
        this.showNewRefrigerators = false;
      }
    }
  }

  public isFormGroupInvalid(): boolean {
    return (this.showUsedRefrigerators && this.formGroup.get('used_refrigerator_count').value === null)
      || (this.showUsedRefrigerators && this.formGroup.get('used_refrigerator_count').value !== null && this.stock &&
        this.formGroup.get('used_refrigerator_count').value > this.stock.available_budget)
     || (this.showNewRefrigerators && this.formGroup.get('new_refrigerator_count').value === null)
      || (this.showNewRefrigerators && this.formGroup.get('new_refrigerator_count').value !== null && this.stock &&
        this.formGroup.get('new_refrigerator_count').value > this.stock.available_budget)
      || (this.stock && this.stock.message);
  }

  public submit(): any {
    return this.formGroup.getRawValue();
  }
}
